var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('student-marks-calendar-selector',{attrs:{"selected-year":_vm.year,"selected-month":_vm.month},on:{"change":_vm.onChangeMonth}}),_c('student-marks-calendar',{attrs:{"monthYear":{year: _vm.year, month: _vm.month}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }